import React from 'react';
import { TRUST_ITEMS } from '../data/content';
export function TrustBar() {
  const items = [...TRUST_ITEMS, ...TRUST_ITEMS];
  return <div className="w-full overflow-hidden bg-forest-deep py-4" data-id="element-302" data-mp="1c1oxxvkh7qtl">
      <div className="flex w-max marquee-track" data-id="element-303" data-mp="y9iiyct27pvq">
        {items.map((item, i) => <div key={i} className="flex items-center whitespace-nowrap px-8" data-id="element-304" data-mp="137als1v8swep" data-mpi={i}>
            <span className="mr-2 text-lg" data-id="element-305" data-mp="135g2st3j7ed9">{item.icon}</span>
            <span className="text-sm font-medium tracking-wide text-ivory/90" data-id="element-306" data-mp="1qxwi4vvvws8v">{item.label}</span>
            <span className="ml-8 text-sage" data-id="element-307" data-mp="1uxor39p6x0er">•</span>
          </div>)}
      </div>
    </div>;
}